import { differenceInYears, format } from 'date-fns';

import i18n from 'i18next';
import isValidDate from './is-valid-date';

type Params = {
  birthDate?: Date;
  getYears?: boolean;
  fallback?: string;
};

export default function getBirthDay(params: Params) {
  const { birthDate, getYears = true, fallback = '-' } = params;
  if (!(birthDate instanceof Date)) return fallback;
  if (!isValidDate(birthDate)) return fallback;
  const birthDateString = birthDate ? format(birthDate, 'dd.MM.yyyy') : '';
  if (!getYears) return birthDateString;
  const years = birthDate ? differenceInYears(new Date(), birthDate) : null;
  const yearsString = years ? i18n.t('ages', { count: years }) : '';
  return birthDateString ? `${birthDateString} (${yearsString})` : '-';
}
